import * as ui from './ui.js'
import * as auth from './auth.js';
import * as player from './player.js'
import { sendExternalEvent } from './events.js';

let sonikit;
export const init = (instance) => {
  sonikit = instance;
}

export const execute = async (patch, service, media_id, media_type) => {
  try {
    if (!sonikit || !sonikit.user) return console.log('Sonikit user invalid');
  
    if (patch.action === 'player') player.init(sonikit, patch, service);

    const body = {
      service_id: service.id,
      media_id,
      media_type,
      fan_id: sonikit.user._id,
      contact_token: sonikit.storage.contact_token, 
      contact_id: sonikit.storage.contact_id,
      source_url: window.location.href, 
      referrer_url: document.referrer
    }
    
    const response = await fetch(`${sonikit.base_url}/action`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${sonikit.project.id}`, 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })

    if (!response.ok) return auth.clearSessions();

    // Reset temp storage
    sonikit.storage.contact_id = null;
    sonikit.storage.contact_token = null;
    localStorage.setItem('sonikit-store', JSON.stringify(sonikit.storage));
    
    if (patch.show_confirmation) ui.showConfirmation(patch, service);
    sonikit.emit('actionComplete', { status: 'success', action: patch.action, service: service.name, patch_id: patch.id } );

    sendExternalEvent(sonikit.project, patch, service);
    processAdapters(patch, service);
  } catch (error) {
    console.log(error)
    return { error: 'Unknown server action error' }
  }
}

export const processAdapters = (patch, service) => {
  let has_reward = false;
  for (const adapter of patch.adapters) {
    if (adapter.action === 'reward')  {
      has_reward = true;
      ui.unlockContent(adapter.parent_patch, adapter, request.data);
    } else if (adapter.action === 'player') {
      const adapter_service = adapter.services.find(x => x.name === service.name);
      player.init(sonikit, adapter, adapter_service);
    }
  }
}

export async function handleClick(patch, service) {
  const button = document.querySelector(`.sonikit-service[data-id="${service.id}"]`)

  if (button && button.dataset.role === 'link') {
    window.open(button.dataset.url, '_blank');
  } else if (sonikit.user && sonikit.user.service === service.name) {
    execute(patch, service)
  } else {
    auth.trigger(patch, service);
  }
}